// TEMPORARY pilot full resync: remove with the admin full-resync endpoint.
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { syncService } from '../../services/syncService';
import { useToastStore } from '../../stores/toastStore';
import { ReadScope, SyncType } from '../../types/sync/enums';
import { TranslationKey } from '../../i18n/translationKeys';
import type { UseFullResyncParams, UseFullResyncResult } from './types';

const FULL_RESYNC_COOLDOWN_MS = 60 * 60 * 1000;

export const useFullResync = ({ syncing, trigger }: UseFullResyncParams): UseFullResyncResult => {
    const { t, i18n } = useTranslation();
    const showToast = useToastStore(s => s.showToast);
    const [promptOpen, setPromptOpen] = useState(false);

    useEffect(() => { if (syncing) setPromptOpen(false); }, [syncing]);

    const checkCooldownThenOpen = async () => {
        try {
            const { lastFullSyncAt } = await syncService.getStatus();
            const availableAt = lastFullSyncAt && new Date(lastFullSyncAt.getTime() + FULL_RESYNC_COOLDOWN_MS);
            if (availableAt && availableAt > new Date()) {
                const when = availableAt.toLocaleString(i18n.language, { dateStyle: 'short', timeStyle: 'short' });
                showToast('error', t(TranslationKey.Home.LastSync.FullResync.Cooldown, { when }));
                return;
            }
            setPromptOpen(true);
        } catch {
            showToast('error', t(TranslationKey.Settings.SyncFailed));
        }
    };

    return {
        promptOpen,
        request: () => void checkCooldownThenOpen(),
        confirm: () => {
            setPromptOpen(false);
            void trigger(SyncType.Full, ReadScope.Complete, true);
        },
        cancel: () => setPromptOpen(false),
    };
};
